import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TreatmentPlanListItem } from '../../../../models/api/view/claim/details/case-management/treatment-plan-list-response';
import { LinkLabelComponent } from '../../../core/labels/link-label.component';
import { ProgressbarComponent } from '../../../core/labels/progressbar.component';
import { EmptyStateComponent } from '../../../core/panels/empty-state.component';
import { ColumnComponent } from '../../../core/table/column.component';
import { TableComponent } from '../../../core/table/table.component';

@Component({
  selector: 'app-case-treatment-plan-list',
  imports: [
    TableComponent,
    ColumnComponent,
    EmptyStateComponent,
    ProgressbarComponent,
    LinkLabelComponent,
  ],
  template: `
    @if (loading) {
      <app-empty-state
        height="300px"
        icon="fa-light fa-clipboard-list-check"
        label="Loading Treatment Plans"
        message="Retrieving treatment plan list"
      >
        <div class="tw-py-4">
          <app-progressbar />
        </div>
      </app-empty-state>
    } @else {
      <div class="treatment-plan-table-scroll">
        <app-table
          [dataSource]="dataSource"
          [pageSize]="10"
          [scrollable]="true"
          recordLabel="Treatment Plan"
          [stripedRows]="false"
        >
          <app-column label="Service" name="serviceName">
            <ng-template let-data>
              <app-link-label (click)="onRowClick(data)">{{
                data.serviceName
              }}</app-link-label>
            </ng-template>
          </app-column>
          <app-column name="status" label="Status" />
          <app-column name="receivedDate" label="Received Date" format="d" />
          <app-column name="startDate" label="Start Date" format="d" />
          <app-column name="endDate" label="End Date" format="d" />
          <app-column name="provider" label="Provider">
            <ng-template let-data>
              {{ data.provider?.name }}
            </ng-template>
          </app-column>
          <app-column name="referenceNumbers" label="Ref #">
            <ng-template let-data>
              {{ data.referenceNumbers?.join(', ') }}
            </ng-template>
          </app-column>
          <app-column name="procedureCategories" label="Procedure Category">
            <ng-template let-data>
              {{ data.procedureCategories?.join(', ') }}
            </ng-template>
          </app-column>
          <app-column name="type" label="Type" />
        </app-table>
      </div>
    }
  `,
  styles: [
    `
      .treatment-plan-table-scroll {
        width: 100%;
        min-width: 0;
        overflow-x: auto;
      }

      .treatment-plan-table-scroll ::ng-deep table {
        min-width: max-content;
        width: 100%;
        border-collapse: collapse;
      }
    `,
  ],
})
export class CaseTreatmentPlanListComponent {
  @Input() dataSource: TreatmentPlanListItem[] = [];
  @Input() loading = false;
  @Output() rowSelected = new EventEmitter<TreatmentPlanListItem>();

  onRowClick(data: TreatmentPlanListItem): void {
    this.rowSelected.emit(data);
  }
}
